export default "__VITE_ASSET__CBiB3dU0__"